var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.insideList)?_c('li',{staticClass:"binds-subheader",class:[_vm.$bindsActiveTheme]},[_vm._t("default")],2):_c('div',{staticClass:"binds-subheader",class:[_vm.$bindsActiveTheme]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }